export default __webpack_public_path__ + "static/media/2.7d9b75dc.png";